import {Route, Routes, useLocation, useNavigate, Navigate} from "react-router-dom";
import Auth from "./pages/Auth"
import ResetPassword from "./pages/ResetPassword"
import Playground from "./pages/Playground"
import Preview from "./pages/Preview";
import ReimagineAI from "./pages/ReimagineAI";
import Navbar2 from "./components/Navbar2";
import React, {useEffect, useRef, useState} from "react";
import Sidebar from "./components/Sidebar";
import Vton from "./pages/vton/Vton";
import Credits from "./pages/Credits";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
// import OutfitAI from "./pages/OutfitAI";
import HumanModelGeneration from "./pages/HumanModelGeneration"
import Verification from "./pages/Verification";
import { useMediaQuery } from "react-responsive";
// import OutfitCaptionAI from "./pages/OutfitCaptionAI";
import UserOnboardingDetails from "./pages/admin/UserOnboardingDetails";
import Dashboard from "./pages/admin/Dashboard";
// import Users from "./pages/admin/Users";    
// import Experiments from "./pages/admin/Experiments";
import { useSelector } from "react-redux";
import { selectUserData, selectAuthenticated, selectAccessToken } from "./selectors";
import MyImages from "./pages/MyImages";
import Docs from "./pages/Docs";
import { boot, update } from "@intercom/messenger-js-sdk";
import Intercom from '@intercom/messenger-js-sdk';
import { updateUser, fetchUser } from "./Utils/UserUtils";
import {setUserData, setUserID} from "./store/AuthActions";
import { useDispatch } from "react-redux";
import Generate from "./pages/Generate";
import { MINIMUM_CREDITS_TO_SHOW_BUY_CREDITS_POPUP } from "./config";
import PromptGallery from "./components/PromptGallery";
import Feedback from "./pages/Feedback";
import TryOnStudio from "./pages/TryOnStudio";
import Pricing from "./pages/Pricing";
import Inspiration from "./pages/Inspiration";
import ModelGenerator from "./pages/ModelGenerator";
import PromptModel from "./components/Promptmodel";
import FashionPromptBuilder from "./fashion-prompt-builder/FashionPromptBuilder";
import TryOnAgent from "./pages/TryOnAgent";
import TermsAndConditions from "./pages/terms-and-conditions/TermsAndConditions";
import CancellationAndRefundPolicy from "./pages/terms-and-conditions/CancellationAndRefundPolicy";
import ContactUs from "./pages/terms-and-conditions/ContactUs";
import PrivacyPolicy from "./pages/terms-and-conditions/PrivacyPolicy";
import NotFound from "./pages/NotFound";
import UserOnboarding from "./onboarding/pages/UserOnboarding";

const App = () => {
    const location = useLocation();
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
        try {
            return localStorage.getItem("sidebarCollapsed") === "true";
        } catch (error) {
            return false;
        }
    });
    const [currentOption, setCurrentOption] = useState("/");
    const [options, setOptions] = React.useState({
        "/myimages": false,
        "/agent": false,
        "/tryonai": false,
        "/model-generator": false,
        "/aimodel": false,
        "/reimagineai": false,
        "/generate": false,
        "/tryonstudio": false,
        // "/inspiration": false,
        // "/outfitai": false,
        // "/outfitcaptionai": false,
        "/credits": false,
        "/profile": false,
        "/pricing": false,
        "/docs": false,
        "/admin/dashboard": false,
        "/admin/useronboardingdetails": false,
        "/admin/users": false,
        "/admin/experiments": false,
    });
    const path_title_mapping = {
        "/": {title: "Playground", description: "Generate, Reimagine, and Try On"},
        "/myimages": {title: "My Images", description: "View your images"},
        "/model-generator": {title: " Model Generator", description: "Generate fashion models with advanced AI"},
        "/aimodel": {title: "Model Swap", description: "Replace the person in a photo"},
        "/tryonai": {title: "Virtual Try-On", description: "Try on clothes virtually"},
        "/vton": {title: "Virtual Try-On", description: "Try on clothes virtually"},
        "/reimagineai": {title: "Reimagine", description: "Reimagine your images with AI"},
        "/generate": {title: "Generate", description: "Generate fashion images with AI"},
        "/tryonstudio": {title: "Studio", description: "Remove a background, upscale, edit, or caption a photo"},
        "/agent": {title: "Ask TryOn", description: "Describe what you want, or attach a photo"},
        // "/inspiration": {title: "Inspiration", description: "Find fashion inspiration"},
        // "/outfitai": {title: "Outfit", description: "Generate outfits with AI"},
        // "/outfitcaptionai": {title: "Outfit Caption", description: "Generate captions for your outfits"},
        "/credits": {title: "Credits", description: "Purchase credits to use our AI features"},
        "/profile": {title: "Profile", description: "View and edit your profile information"},
        "/settings": {title: "Settings", description: "Appearance and preferences"},
        "/pricing": {title: "Pricing", description: "Pricing for our Fashion AI Tools"},
        "/docs": {title: "Docs", description: "Documentation for our AI features"},
        "/feedback": {title: "Feedback", description: "Share your feedback with us"}
        

    }

    const user = useSelector(selectUserData);
    const authenticated = useSelector(selectAuthenticated);
    const sidebarRef = useRef(null);
    const navigate = useNavigate();
    const isMobile = useMediaQuery({ query: `(max-width: 760px)` })
    const userData = JSON.parse(useSelector(selectUserData));
    const [showWelcomePopup, setShowWelcomePopup] = useState(false);
    const accessToken = useSelector(selectAccessToken)
    const dispatch = useDispatch()
    const [fetchingUserData, setFetchingUserData] = useState(false);
    const [userDataFetched, setUserDataFetched] = useState(false);
    const minimumCreditsToShowBuyCreditsPopup = MINIMUM_CREDITS_TO_SHOW_BUY_CREDITS_POPUP
    const [showBuyCreditsPopup, setShowBuyCreditsPopup] = useState(false);
    const [showPromptGalleryModal, setShowPromptGalleryModal] = useState(false);
    const [selectedPrompt, setSelectedPrompt] = useState(null);
    const [promptType, setPromptType] = useState("all");

    const getShowBuyCreditsPopup = (userCredits) => {
        let showBuyCreditsPopup1 = localStorage.getItem("SHOW_BUY_CREDITS_POPUP") === null ? true : localStorage.getItem("SHOW_BUY_CREDITS_POPUP") === "true"
        if(showBuyCreditsPopup1 && userCredits <= MINIMUM_CREDITS_TO_SHOW_BUY_CREDITS_POPUP){
            return true
        }else{
            return false
        }
    }

    useEffect(() => {
        if(userData?.show_welcome_popup){
            setShowWelcomePopup(true)
        }
    }, [userData])

    useEffect(() => {
        console.log("Apps useEffect")
        let option = location.pathname;

        console.log("Pathname:", option)
        setCurrentOption(option)

        // Create a new options object instead of mutating the existing one
        const updatedOptions = Object.keys(options).reduce((acc, key) => {
            acc[key] = key === option;
            return acc;
        }, {});

        console.log("Updated options:", updatedOptions)
        setOptions(updatedOptions)
        setSelectedPrompt(null)
        setShowPromptGalleryModal(false)
        
        if(isMobile){
            closeSideBar()
        }else{
            openSideBar()
        }
    }, []);

    // Keep the sidebar selection in step with in-page navigation (e.g. the home
    // prompt opening /agent/:id), not just with sidebar clicks.
    useEffect(() => {
        const base = location.pathname.startsWith("/agent/") ? "/agent" : location.pathname;
        setCurrentOption(base);
        setOptions((prev) => Object.keys(prev).reduce((acc, key) => {
            acc[key] = key === base;
            return acc;
        }, {}));
    }, [location.pathname]);

    // Separate useEffect for Intercom management
    useEffect(() => {
        const authPages = ["/signup", "/signin", "/verify"];
        const isAuthPage = authPages.includes(location.pathname);
        const intercomAppId = process.env.REACT_APP_INTERCOM_APP_ID;

        if (!intercomAppId) {
            console.error('Intercom App ID is not defined');
            return;
        }

        try {
            // Always boot first with app ID
            Intercom({app_id: intercomAppId});

            if (isAuthPage) {
                console.log("Auth page - hiding Intercom");
                window.Intercom('shutdown');
                return;
            }

            // Show Intercom on non-auth pages
            window.Intercom('boot', {
                app_id: intercomAppId,
            });

            if (authenticated && user) {
                try {
                    // Safely parse user data
                    const parsedUser = typeof user === 'string' ? JSON.parse(user) : user;
                    
                    console.log("Updating Intercom with user data:", {
                        id: parsedUser?.id,
                        name: parsedUser?.first_name,
                        email: parsedUser?.email
                    });

                    // Update with user data
                    update({
                        user_id: parsedUser?.id,
                        name: parsedUser?.first_name,
                        email: parsedUser?.email,
                        created_at: Date.now()
                    });
                } catch (parseError) {
                    console.error('Error parsing user data:', parseError);
                }
            }
        } catch (error) {
            console.error('Error in Intercom initialization:', error);
        }
    }, [location.pathname, authenticated, user]);

    // Add this useEffect near the top of the component with other useEffects
    useEffect(() => {
        // When modal is shown (showWelcomePopup is false), disable body scroll
        if (!showWelcomePopup) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        // Cleanup function to re-enable scrolling when component unmounts
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [showWelcomePopup]);

    const toggleSidebar = () => {
        setSidebarOpen(choice => !choice);
    };

    function handleOptionSelect(option, options) {
        console.log("Option selected:", option, options)
        setOptions(options)
        navigateToPage(option)
        if(isMobile){
            closeSideBar()
        }
    }

    const navigateToPage = (selectedOption) => {
        if (currentOption === selectedOption) {
            console.log("You clicked on the same option:", currentOption)
        } else {
            console.log("Navigating to page:", selectedOption)
            setCurrentOption(selectedOption)
            setSelectedPrompt(null)
            navigate(selectedOption)
        }
    }

    const closeSideBar = () => {
        setSidebarOpen(false);
    }

    const toggleSidebarCollapsed = () => {
        setSidebarCollapsed((collapsed) => {
            const next = !collapsed;
            try {
                localStorage.setItem("sidebarCollapsed", String(next));
            } catch (error) {
                console.error("Could not store sidebar state", error);
            }
            return next;
        });
    }

    const openSideBar = () => {
        setSidebarOpen(true);
    }

    const RouteWrapper = ({ element, path }) => {
        console.log("RouteWrapper", userData?.is_staff, path)
        const routeExists = userData?.is_staff;
        return routeExists ? element : <Navigate to="/" />;
    };

    const hideWelcomePopup = async () => {
        const response = await updateUser({show_welcome_popup: false}, accessToken)
        console.log("Hide welcome popup response", response)
        if(response.status === "success"){
            dispatch(setUserID(response.data.id))
            dispatch(setUserData(JSON.stringify(response.data)))
            setShowWelcomePopup(false)
        }else{
            console.log("Error hiding welcome popup", response)
            setShowWelcomePopup(false)
        }
    }

    useEffect(() => {
        const held = Number(userData?.credits_on_hold) || 0;
        if (!held || !accessToken) return undefined;
        const timer = setInterval(async () => {
            const response = await fetchUser(accessToken);
            if (response?.status === "success") dispatch(setUserData(JSON.stringify(response.data)));
        }, 5000);
        return () => clearInterval(timer);
    }, [userData?.credits_on_hold, accessToken, dispatch]);

    useEffect(() => {
        if(userDataFetched){
            return
        }
        const fetchUserData = async () => {
            setFetchingUserData(true)
            const response = await fetchUser(accessToken)
            console.log("Fetch user data response", response)
            if(response.status === "success"){
                dispatch(setUserID(response.data.id))
                dispatch(setUserData(JSON.stringify(response.data)))
                setUserDataFetched(true)

                // check the number of credits the user has
                const owned = Number(response.data.credits || 0) + Number(response.data.credits_on_hold || 0);
                if(getShowBuyCreditsPopup(owned)){
                    // show buy more credits popup
                    console.log("Show buy credits popup")
                    setShowBuyCreditsPopup(true)
                    localStorage.setItem("SHOW_BUY_CREDITS_POPUP", "true")
                }
            }else{
                console.log("Error fetching user data", response)
                setUserDataFetched(true)
            }
            setFetchingUserData(false)
        }
        fetchUserData()
    }, [accessToken])

    const getTitleDescription = () => {
        console.log("getTitle", location.pathname)
        const titlePath = location.pathname.startsWith("/agent/") ? "/agent" : location.pathname
        return path_title_mapping[titlePath] || {title: "TryOn AI", description: "Generate, Reimagine, and Try On"}
    }

    const handleBuyCreditsOptionSelect = (numOfCredits) => {
        setShowBuyCreditsPopup(false)
        localStorage.setItem("SHOW_BUY_CREDITS_POPUP", "false")
        navigate(`/credits?buy_credits=true&num_of_credits=${numOfCredits}`)
    }

    const handlePromptSelect = (prompt) => {
        console.log("Prompt selected", prompt)
        setSelectedPrompt(prompt)
        setShowPromptGalleryModal(false)
    }

    const showPromptGalleryModal1 = (promptType) => {
        setPromptType(promptType)
        setShowPromptGalleryModal(true)
    }

    // Helper function to check if pathname should hide sidebar/navbar
    const shouldHideSidebarNavbar = () => {
        const hidePaths = [
            "/signin",
            "/signup",
            "/auth",
            "/verify",
            "/reset-password",
            "/terms-and-conditions",
            "/cancellation-and-refund-policy",
            "/contact-us",
            "/privacy-policy",
            "/onboarding"
        ];
        
        // Check if it's an exact match with hide paths
        if (hidePaths.includes(location.pathname)) {
            return true;
        }
        
        // Check if it's a valid route (not 404)
        const validRoutes = [
            "/",
            "/tryonai",
            "/vton",
            "/aimodel",
            "/reimagineai",
            "/generate",
            "/tryonstudio",
            "/agent",
            "/inspiration",
            "/credits",
            "/profile",
            "/settings",
            "/docs",
            "/pricing",
            "/feedback",
            "/model-generator",
            "/fashion-prompt-builder",
            "/myimages",
            "/terms-and-conditions",
            "/cancellation-and-refund-policy",
            "/contact-us",
            "/privacy-policy",
            "/onboarding"
        ];
        
        // Check if pathname matches a valid route or starts with /admin or /preview
        const isValidRoute = validRoutes.includes(location.pathname) ||
            location.pathname.startsWith("/admin/") ||
            location.pathname.startsWith("/agent/") ||
            location.pathname.startsWith("/preview/");
        
        // If not a valid route, hide sidebar/navbar (it's a 404)
        return !isValidRoute;
    };

    const hideSidebarNavbar = shouldHideSidebarNavbar();

    return (
        <>
            {hideSidebarNavbar ? (<></>) : (
            <Sidebar ref={sidebarRef} handleOptionSelect={handleOptionSelect} isSidebarOpen={isSidebarOpen}
                     closeSideBar={closeSideBar} collapsed={sidebarCollapsed} toggleCollapsed={toggleSidebarCollapsed} options={options} isAdmin={location.pathname.includes("/admin")}/>)}

            <div className={hideSidebarNavbar ? "md:ml-0" : sidebarCollapsed ? "transition-[margin] duration-200 md:ml-[4.5rem]" : "transition-[margin] duration-200 md:ml-64"}>
            {hideSidebarNavbar ? (<></>) : (
                <Navbar2 title_description={getTitleDescription()} toggleSidebar={toggleSidebar} handleOptionSelect={handleOptionSelect} options={options}/>)}

                <Routes>
                    <Route path="/signup" element={<Auth/>}/>
                    <Route path="/signin" element={<Auth/>}/>
                    <Route path="/auth" element={<Auth/>}/>
                    <Route path="/reset-password" element={<ResetPassword/>}/>
                    <Route path="/" element={<Playground options={options} handleOptionSelect={handleOptionSelect}/>}/>
                    <Route path="/tryonai" element={<Vton/>}/>
                    <Route path="/vton" element={<Vton/>}/>
                    <Route path="/aimodel" element={<HumanModelGeneration/>}/>
                    <Route path="/reimagineai" element={<ReimagineAI selectedPrompt={selectedPrompt} setShowPromptGalleryModal={setShowPromptGalleryModal} showPromptGalleryModal={showPromptGalleryModal1}/>}/>
                    <Route path="/generate" element={<Generate selectedPrompt={selectedPrompt} setShowPromptGalleryModal={setShowPromptGalleryModal} showPromptGalleryModal={showPromptGalleryModal1}/>}/>
                    <Route path="/tryonstudio" element={<TryOnStudio selectedPrompt={selectedPrompt} setShowPromptGalleryModal={setShowPromptGalleryModal} onSelectPrompt={handlePromptSelect} showPromptGalleryModal={showPromptGalleryModal1}/>}/>
                    <Route path="/inspiration" element={<Inspiration/>}/>
                    <Route path="/credits" element={<Credits/>}/>
                    <Route path="/profile" element={<Profile/>}/>
                    <Route path="/settings" element={<Settings/>}/>
                    <Route path="/docs" element={<Docs/>}/>
                    <Route path="/pricing" element={<Pricing/>}/>
                    <Route path="/feedback" element={<Feedback/>}/>
                    <Route path="/verify" element={<Verification/>}/>
                    <Route path="/model-generator" element={<ModelGenerator selectedPrompt={selectedPrompt} setShowPromptGalleryModal={setShowPromptGalleryModal} showPromptGalleryModal={showPromptGalleryModal1}/>}/>
                    <Route path="/fashion-prompt-builder" element={<FashionPromptBuilder/>}/>
                    <Route path="/agent" element={<TryOnAgent/>}/>
                    <Route path="/agent/:sessionId" element={<TryOnAgent/>}/>

                    <Route path="/terms-and-conditions" element={<TermsAndConditions/>}/>
                    <Route path="/cancellation-and-refund-policy" element={<CancellationAndRefundPolicy/>}/>
                    <Route path="/contact-us" element={<ContactUs/>}/>
                    <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>

                    <Route path="/preview/:garment_url/:model_url/:tryon_url" element={<Preview/>}/>
                    {/* <Route path="/outfitai" element={<OutfitAI selectedPrompt={selectedPrompt} setShowPromptGalleryModal={setShowPromptGalleryModal}/>}/>
                    <Route path="/outfitcaptionai" element={<OutfitCaptionAI/>}/> */}
                    <Route path="/myimages" element={<MyImages/>}/>
                    <Route path="/onboarding" element={<UserOnboarding/>}/>
                    
                    <Route path="/admin/dashboard" element={<RouteWrapper element={<Dashboard />} path="/admin/dashboard" />} />
                    <Route path="/useronboardingdetails" element={<RouteWrapper element={<UserOnboardingDetails />} path="/admin/useronboardingdetails" />} />
                    {/* <Route path="/admin/users" element={<RouteWrapper element={<Users />} path="/admin/users" />} />
                    <Route path="/admin/experiments" element={<RouteWrapper element={<Experiments />} path="/admin/experiments" />} /> */}
                    
                    {/* Catch-all route for 404 - must be last */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </div>

            {/* show a welcome to TryOn AI Playground popup for new users */}
            {showWelcomePopup && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-overlay p-4">
                    <div className="relative max-h-[90vh] w-full max-w-md overflow-y-auto rounded-2xl bg-white p-6 shadow-[0_0_0_1px_var(--hairline)]">
                        <button
                            type="button"
                            onClick={hideWelcomePopup}
                            aria-label="Close"
                            className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-white font-Mulish text-sm text-primary-700 shadow-[0_0_0_1px_var(--hairline)]"
                        >
                            ×
                        </button>
                        <h2 className="pr-8 font-Mulish text-lg font-semibold text-secondary">Welcome to TryOn AI</h2>
                        <div className="mt-4 rounded-2xl bg-primary-50 px-6 py-5 text-center">
                            <div className="font-newsreader text-[40px] font-medium leading-none tracking-tight text-secondary tabular-nums">100</div>
                            <div className="mt-2 font-Mulish text-[13px] text-graphite">credits</div>
                        </div>
                        <div className="mt-4 space-y-2 font-Mulish text-sm text-graphite">
                            <p>Your account starts with these credits.</p>
                            <p>Try a garment on, or generate an image.</p>
                            <p>
                                Need help?{" "}
                                <a className="text-primary-700" href="https://discord.gg/SuM5Xr9nn9" target="_blank" rel="noopener noreferrer">Join the Discord channel</a>
                            </p>
                        </div>
                        <button
                            type="button"
                            onClick={hideWelcomePopup}
                            className="mt-6 w-full rounded-full bg-primary-700 px-4 py-2.5 font-Mulish text-sm font-semibold text-white shadow-[0_12px_28px_-10px_rgba(190,49,32,0.65)]"
                        >
                            Start exploring
                        </button>
                        <p className="mt-4 text-center font-Mulish text-sm text-graphite">
                            <a href="mailto:contact@tryonlab.ai" className="text-primary-700">Contact our support team</a>
                        </p>
                    </div>
                </div>
            )} 

            {(showBuyCreditsPopup || localStorage.getItem("SHOW_BUY_CREDITS_POPUP") === "true") && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-overlay p-4">
                    <div className="relative max-h-[90vh] w-full max-w-md overflow-y-auto rounded-2xl bg-white p-6 shadow-[0_0_0_1px_var(--hairline)]">
                        <button
                            type="button"
                            onClick={() => { setShowBuyCreditsPopup(false); localStorage.setItem("SHOW_BUY_CREDITS_POPUP", "false"); }}
                            aria-label="Close"
                            className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-white font-Mulish text-sm text-primary-700 shadow-[0_0_0_1px_var(--hairline)]"
                        >
                            ×
                        </button>
                        <h2 className="pr-8 font-Mulish text-lg font-semibold text-secondary">Running low on credits</h2>
                        <p className="mt-1 font-Mulish text-sm text-graphite">Choose an amount to keep going.</p>
                        <div className="mt-4 flex flex-wrap gap-8">
                            <div>
                                <div className="font-newsreader text-[40px] font-medium leading-none tracking-tight text-secondary tabular-nums">
                                    {userData?.credits ?? 0}
                                </div>
                                <div className="mt-2 font-Mulish text-[13px] text-graphite">{Number(userData?.credits_on_hold) > 0 ? "available" : "credits left"}</div>
                            </div>
                            {Number(userData?.credits_on_hold) > 0 && (
                                <div>
                                    <div className="font-newsreader text-[40px] font-medium leading-none tracking-tight text-secondary tabular-nums">
                                        {userData.credits_on_hold}
                                    </div>
                                    <div className="mt-2 font-Mulish text-[13px] text-graphite">on hold</div>
                                </div>
                            )}
                        </div>
                        <div className="mt-6 overflow-hidden rounded-2xl shadow-[0_0_0_1px_var(--hairline)]">
                            {[
                                { credits: 1000, price: "$10", lead: true },
                                { credits: 200, price: "$2" },
                                { credits: 500, price: "$5" },
                                { credits: 10000, price: "$100" },
                            ].map((pack) => (
                                <button
                                    key={pack.credits}
                                    type="button"
                                    onClick={() => handleBuyCreditsOptionSelect(pack.credits)}
                                    className={`flex w-full items-center justify-between px-4 py-3 text-left hover:bg-hover-tint ${pack.lead ? "bg-primary-50" : "border-t border-hairline bg-white"}`}
                                >
                                    <span className="font-Mulish text-sm font-semibold text-secondary">{pack.credits.toLocaleString()} credits</span>
                                    <span className="flex items-center gap-2">
                                        {pack.lead ? (
                                            <span className="rounded-full bg-white px-3 py-1 font-Mulish text-sm text-primary-700 shadow-[0_0_0_1px_var(--hairline)]">Best value</span>
                                        ) : null}
                                        <span className="font-newsreader text-2xl font-medium leading-none tracking-tight text-secondary tabular-nums">{pack.price}</span>
                                    </span>
                                </button>
                            ))}
                        </div>
                        <button
                            type="button"
                            onClick={() => handleBuyCreditsOptionSelect(1000)}
                            className="mt-6 w-full rounded-full bg-primary-700 px-4 py-2.5 font-Mulish text-sm font-semibold text-white shadow-[0_12px_28px_-10px_rgba(190,49,32,0.65)]"
                        >
                            Buy 1000 credits
                        </button>
                        <button
                            type="button"
                            onClick={() => { setShowBuyCreditsPopup(false); localStorage.setItem("SHOW_BUY_CREDITS_POPUP", "false"); }}
                            className="mt-3 w-full rounded-full border border-primary-200 bg-white px-4 py-2.5 font-Mulish text-sm text-primary-700 hover:bg-primary-50"
                        >
                            Dismiss
                        </button>
                    </div>
                </div>
            )}

            {showPromptGalleryModal && <PromptModel setShowPromptGalleryModal={setShowPromptGalleryModal} onSelectPrompt={handlePromptSelect} promptType={promptType} />}
        </>
    );
};

export default App;
